import React from "react";
import styles from "./ExportOptionsBar.module.css";

function ExportOptionsBar({
  useExportAndResolution,
  setUseExportAndResolution,
  exportFormat,
  setExportFormat,
  exportQuality,
  setExportQuality,
  globalOutputSize,
  setGlobalOutputSize,
  maxWidth,
  setMaxWidth,
  maxHeight,
  setMaxHeight,
  referenceBox,
  setReferenceBox,
  exportFormats,
  outputSizePresets,
  referenceBoxValues,
}) {
  const selectCls = useExportAndResolution ? styles.input : styles.inputDisabled;

  return (
    <div className={styles.bar}>
      <div className={styles.row}>
        <label className={styles.checkWrap}>
          <input
            type="checkbox"
            checked={useExportAndResolution}
            onChange={(e) => setUseExportAndResolution(e.target.checked)}
            className={styles.checkbox}
          />
          <span className={styles.checkLabel}>Custom export</span>
        </label>

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>Format</label>
          <select
            value={exportFormat}
            onChange={(e) => setExportFormat(e.target.value)}
            disabled={!useExportAndResolution}
            className={`${selectCls} ${styles.w96}`}
          >
            {exportFormats.map((f) => (
              <option key={f.value} value={f.value}>{f.label}</option>
            ))}
          </select>
        </div>

        {exportFormat === "jpeg" && (
          <div className={styles.fieldGroup}>
            <label className={styles.fieldLabel}>Quality {exportQuality}</label>
            <input
              type="range"
              min="1"
              max="100"
              value={exportQuality}
              onChange={(e) => setExportQuality(Number(e.target.value))}
              disabled={!useExportAndResolution}
              className={`${styles.checkbox} ${styles.w80}`}
              style={{ opacity: useExportAndResolution ? 1 : 0.6 }}
            />
          </div>
        )}

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>Size</label>
          <select
            value={globalOutputSize}
            onChange={(e) => setGlobalOutputSize(e.target.value)}
            disabled={!useExportAndResolution}
            className={`${selectCls} ${styles.w112}`}
          >
            {outputSizePresets.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>Max W</label>
          <input
            type="number"
            min={1}
            value={maxWidth}
            onChange={(e) => setMaxWidth(e.target.value)}
            className={`${styles.input} ${styles.w80}`}
          />
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>Max H</label>
          <input
            type="number"
            min={1}
            value={maxHeight}
            onChange={(e) => setMaxHeight(e.target.value)}
            className={`${styles.input} ${styles.w80}`}
          />
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel}>Reference</label>
          <select
            value={referenceBox}
            onChange={(e) => setReferenceBox(e.target.value)}
            className={`${styles.input} ${styles.w144}`}
          >
            {referenceBoxValues.map((v) => (
              <option key={v} value={v}>{v}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ExportOptionsBar);
